/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Table cell config for settings statistics
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.3.1
 */

import { ITableField } from '../../../../../../components/Table/reducers/tableReducer';
import { EColumnCell, EColumnFilter } from '../../../../../../components/Table/types/columnTypes';
import { IPageSettingsStatisticsTableTranslation } from '../../../../../../modules/internationalization/types/pages/pageSettings';
import { ESettingsStatisticsField } from './settingsStatisticsTableTypes';

export const SettingsSettingsCellConfig: {[key in ESettingsStatisticsField]: number} = {
    [ESettingsStatisticsField.DATE]: 440,
    [ESettingsStatisticsField.IP_ADDRESS]: 440,
}

export const getSettingsStatisticsColumnFilterType = (name: string): string => {
    switch (name) {
        case ESettingsStatisticsField.DATE:
            return EColumnFilter.filterDate;
        case ESettingsStatisticsField.IP_ADDRESS:
        default:
            return '';
    }
}

export const getSettingsStatisticsColumnCellType = (name: ESettingsStatisticsField): EColumnCell => {
    switch (name) {
        case ESettingsStatisticsField.DATE:
            return EColumnCell.createDate;
        case ESettingsStatisticsField.IP_ADDRESS:
        default:
            return EColumnCell.text;
    }
}

type TFormStatisticsTableField =
    (props: Partial<Pick<ITableField<ESettingsStatisticsField>, 'name' | 'label' | 'order'>>) =>
        ITableField<ESettingsStatisticsField>

export const formStatisticsTableField: TFormStatisticsTableField = (props) => ({
    name: props.name ?? ESettingsStatisticsField.DATE,
    label: props.label ?? '',
    checked: true,
    order: props.order ?? 0,
    resizable: false,
    size: 440,
    type: 'S',
})

export const formStatisticsTableFields =
    (translation: IPageSettingsStatisticsTableTranslation): Array<ITableField<ESettingsStatisticsField>> => {
    const dateField = formStatisticsTableField({
        name: ESettingsStatisticsField.DATE,
        order: 0,
        label: translation[ESettingsStatisticsField.DATE],
    })

    const ipAddressField = formStatisticsTableField({
        name: ESettingsStatisticsField.IP_ADDRESS,
        order: 1,
        label: translation[ESettingsStatisticsField.IP_ADDRESS],
    })

    return [dateField, ipAddressField];
}
